module.exports = __webpack_public_path__ + "static/img/jingxin.9ce7f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/jingxin.png?20181011
// module id = Jynl
// module chunks = 1